import ReportView, { type ReportColumn } from '../../../components/reports/ReportView';
import { useConfig, listOptions } from '../../../context/ConfigContext';

// TS port of the source (Falah) app's pages/reports/revenue/ReceiptsSummaryReport.jsx.
const COLUMNS: ReportColumn[] = [
  { key: 'receipt_number', label: 'Receipt #' },
  { key: 'payer_name', label: 'Payer' },
  { key: 'invoice_number', label: 'Invoice #' },
  { key: 'type', label: 'Type' },
  { key: 'category', label: 'Category' },
  { key: 'paid_amount', label: 'Amount', align: 'right', type: 'money' },
  { key: 'payment_method', label: 'Method' },
  { key: 'payment_date', label: 'Date' },
  { key: 'received_by', label: 'Received By' },
];

export function ReceiptsSummaryReport() {
  const { lists } = useConfig();

  return (
    <ReportView
      title="Receipts & Collections Summary"
      description="All receipts collected, with payer, method and category."
      endpoint="/reports/revenue/receipts-summary"
      columns={COLUMNS}
      filters={['category', 'dateRange']}
      categoryOptions={listOptions(lists, 'invoice_type')}
    />
  );
}
